import { apiDelete, apiGet, apiPost, apiPut } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueDescription, systemValueLabel, systemValueOptionText } from '../../generic/systemValues/systemValueLabel'

const DeviceStatus = () => {
  const { t_ } = useSmartTranslation()

  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      unique: true,
      mandatory: true,
      readOnly: (row) => {
        return row.systemDefault
      }
    },
    {
      name: t_('Name'),
      field: 'name',
      unique: true,
      mandatory: true,
      readOnly: (row) => {
        return row.systemDefault
      },
      // Story 204 — S76: a seeded row reads by its code (RN2.1); editing shows the real name.
      render: (row) => systemValueLabel(t_, 'status', row),
      renderOnlyInReadMode: true
    },

    {
      name: t_('Status type'),
      field: 'statusType.name',
      type: 'smartSelect',
      render: (row) => systemValueLabel(t_, 'status_type', row.statusType),
      renderOnlyInReadMode: true,
      filterByLabel: { options: (items) => items.map((item) => ({ value: item.name, label: systemValueLabel(t_, 'status_type', item) })) },
      edit: {
        source: async () => {
          return await apiGet('statusTypes')
        },
        id: 'id',
        field: 'name',
        optionLabel: (name, items) => systemValueOptionText(t_, 'status_type', items, name)
      },
      readOnly: (row) => {
        return row.systemDefault
      },
      mandatory: true
    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200,
      // P10: a seeded row's description is factory text and reads translated; a customer row keeps its own.
      render: (row) => systemValueDescription(t_, 'status', row),
      renderOnlyInReadMode: true
    }
  ]

  const actions = {
    create: {
      fetchFunction: (row) => {
        return apiPost('status', row)
      }
    },
    edit: {
      fetchFunction: (row) => {
        return apiPut('status', row)
      }
    },
    delete: {
      visibilityButton: row => !row.systemDefault,
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('status/' + rows[0].id)
        } else {
          return apiDelete('status/deleteMulti/', rows)
        }
      }
    }
  }

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='deviceStatus'
      columns={columns}
      title={t_('Device Status')}
      dataFetch='status'
      actions={actions}
      pageable
      multipleSelection
      safeDeleteShowProperty='name'
    />
  )
}

export default DeviceStatus
